'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiTree = function TiTree(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.6 29l-4.5-5.7h1.6c0.6 0 1.2-0.3 1.4-0.9s0.3-1.2-0.1-1.7l-11.6-16.7c-0.6-0.7-1.6-0.9-2.4-0.4-0.1 0.1-0.2 0.3-0.3 0.4-0.1 0-11.7 16.7-11.7 16.7-0.4 0.5-0.4 1.2-0.1 1.7 0.2 0.6 0.8 0.9 1.4 0.9h1.6l-4.5 5.7c-0.4 0.5-0.5 1.1-0.2 1.7 0.2 0.6 0.8 1 1.5 1h11.6v5c0 0.9 0.8 1.6 1.7 1.6s1.7-0.7 1.7-1.6v-5h11.6c0.7 0 1.3-0.4 1.5-1 0.3-0.6 0.2-1.2-0.2-1.7z m-12.9-0.7v-8.3c0-0.9-0.8-1.7-1.7-1.7s-1.7 0.8-1.7 1.7v8.3h-8.2l4.5-5.6c0.4-0.5 0.5-1.2 0.2-1.8-0.2-0.5-0.8-0.9-1.5-0.9h-1.8l8.5-12.1 8.5 12.1h-1.8c-0.7 0-1.3 0.4-1.5 0.9-0.3 0.6-0.2 1.3 0.2 1.8l4.5 5.6h-8.2z' })
        )
    );
};

exports.default = TiTree;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/tree.js
// module id = 2065
// module chunks = 0